function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    stroke: "none",
    d: " M408.232483,199.268890  C393.991302,214.855240 379.989471,230.176590 366.008606,245.517059  C356.139435,256.345947 346.307007,267.208344 336.442444,278.041443  C329.344940,285.835846 322.073975,293.480408 315.225372,301.486877  C313.730652,303.234283 313.103912,306.233673 313.091583,308.661621  C312.948334,336.824036 312.834320,364.989166 313.126190,393.149292  C313.192291,399.527863 310.416290,403.867126 305.973511,407.460236  C291.302124,419.325562 276.488922,431.015656 261.726379,442.768219  C250.275269,451.884552 238.890717,461.086639 227.338470,470.073059  C219.736954,475.986237 205.076965,473.854523 201.906570,463.528412  C201.348282,461.710083 201.038437,459.738647 201.036652,457.837494  C200.990387,408.177063 200.967453,358.516510 201.065170,308.856232  C201.072540,305.106262 199.850754,302.424683 197.319443,299.713684  C181.450562,282.718506 165.713715,265.599426 150.003006,248.457336  C140.553513,238.146927 131.256821,227.696671 121.844337,217.352112  C107.875816,202.000351 93.832771,186.716293 79.885185,171.345596  C71.381485,161.974213 63.447556,152.038147 54.457798,143.166260  C39.673618,128.575912 36.131847,103.847633 47.052502,86.308281  C55.254776,73.134834 67.012756,65.042366 83.069557,65.033699  C199.388336,64.970932 315.707184,64.962097 432.025940,65.051376  C445.489868,65.061707 455.826172,71.779549 463.973724,82.020027  C475.189362,96.116608 475.506897,111.940918 469.755798,128.010178  C467.866028,133.290451 463.775269,137.985367 459.994995,142.344345  C452.217590,151.312317 443.927460,159.833649 435.928986,168.612289  C426.734039,178.704056 417.626343,188.875305 408.232483,199.268890  z",
    "data-index": 1,
    style: {
      opacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.c3464d10f5878d85754faed98fd932fb.svg";
export { ForwardRef as ReactComponent };